import { catalogosWarmHandlers } from './groups/catalogos'
import { incidenciasWarmHandlers } from './groups/incidencias'

const tabWarmHandlers = [
    ...catalogosWarmHandlers,
    ...incidenciasWarmHandlers,
]

export const normalizeTabWarmPath = (path = '/') => {
    const [pathname] = `${path || '/'}`.split(/[?#]/)
    const normalized = `/${pathname}`.replace(/\/+/g, '/')
    return normalized !== '/' ? normalized.replace(/\/$/, '') : normalized
}

export const findTabWarmHandler = (path) => {
    const normalizedPath = normalizeTabWarmPath(path)

    for (const handler of tabWarmHandlers) {
        const params = handler.match(normalizedPath)
        if (params) {
            return { handler, params }
        }
    }

    return null
}

export const getTabWarmHandlers = () => tabWarmHandlers

